import type { ParsedUrlQuery } from 'querystring';
import AvailabilityAction from '~/constants/availabilityAction';
import AvailabilityError from '~/constants/availabilityError';
import { InventoryTypeKey } from '~/constants/inventoryType';
import Sections from '~/constants/sections';
import SoftPullStatus from '~/constants/softPullStatus';
import {
  clientSideExperiments,
  serverSideExperiments
} from '~/constants/vdp/experiments';
import { VehicleLockTypeKey } from '~/constants/vehicleLockType';
import type { Experiments } from '~/contracts/common';
import type { User, Vehicle } from '~/contracts/vdp';

const user: User = {
  availability: {
    action: AvailabilityAction.GetStartedDisabled,
    error: AvailabilityError.None,
    inventoryType: InventoryTypeKey.Core,
    isAvailableForPurchase: true,
    isBuyingAVehicle: false,
    isError: false,
    isLoaded: false,
    isLoading: false,
    isLockedByThisUser: false,
    isPendingDealerPurchase: false,
    isPendingDealerPurchaseByUser: false,
    lockType: VehicleLockTypeKey.None,
    vehicleAvailableDateTime: ''
  },
  email: '',
  favorites: {
    isError: false,
    isLoaded: false,
    isLoading: false,
    vehicles: []
  },
  financing: {
    data: null,
    hasError: false,
    isLoaded: false,
    isLoading: false
  },
  isLoaded: false,
  isLoading: false,
  isLoggedIn: false,
  location: {
    city: '',
    state: '',
    zip: ''
  },
  referrer: '',
  softPullStatus: SoftPullStatus.None,
  userId: ''
};

const vehicle: Vehicle = {
  alertModals: {
    isError: false,
    isLoading: false,
    recallStatus: []
  },
  analytics: {
    associatedVdpEventId: '',
    correspondingVDPEventId: '',
    correspondingSearchRequestId: ''
  },
  deliveryPickup: {
    data: {
      vehicleId: 0,
      soonestDelivery: {},
      soonestPickup: {}
    },
    hasError: false,
    isLoaded: false,
    isLoading: false
  },
  details: {}, // VDP API response
  hasOwnerReviews: true,
  isDetailsLoaded: false,
  isFavorited: false,
  isSubscribedToNotifications: false,
  spinner: {
    hasError: false,
    inTourMode: false,
    isImmersive: false,
    isScriptInserted: false,
    type: ''
  },
  transitActivityType: null,
  transitCharge: {
    data: -1,
    hasError: false,
    isLoaded: false,
    isLoading: false
  },
  transitRouteId: null
};

export default {
  ui: {
    isLazyLoadEnabled: true,
    isLite: false,
    isSpinnerDisabled: false,
    sectionViewed: {
      [Sections.Gallery]: false,
      [Sections.VehicleDetails]: false,
      [Sections.VehiclesYouMightLike]: false
    },
    sectionMounted: {
      [Sections.Spinner]: true,
      [Sections.Hero]: true,
      [Sections.VehicleDetails]: false,
      [Sections.PriceDetails]: false,
      [Sections.OwnerReviews]: false,
      [Sections.Inspection150Point]: false,
      [Sections.VehiclesYouMightLike]: false
    }
  },
  user,
  experimentation: {
    isServerLoaded: Object.keys(serverSideExperiments).length === 0,
    isClientLoaded: Object.keys(clientSideExperiments).length === 0,
    experiments: {} as Experiments
  },
  vehicle,
  router: {
    queryParams: {} as ParsedUrlQuery,
    hash: ''
  }
};
